
const TokenKey = 'accessToken'

export function getToken() {
  return localStorage.getItem(TokenKey)
}


export function setToken(value) {
  return localStorage.setItem(TokenKey, value)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}


export function isAndroid() {
  var u = window.navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
  return isAndroid
}

export function isIOS() {
  var u = window.navigator.userAgent
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  return isIOS
}




// WEBPACK FOOTER //
// ./src/utils/auth.js